import React from 'react'
import { Container } from 'semantic-ui-react';
import { SocialMedia } from '../components'

const Footer = () => (
  <div style={styles.root} className='Tile'>
    <Container textAlign='center'>
      <h3 style={styles.phoneTitle}>Phone<span style={styles.phoneNo}>+ 91 973-406-5582</span></h3>
      <h1 style={styles.title}>Follow us on</h1>
      <SocialMedia />
      <br/>
      <h4 ><a style={styles.subtitle} href='https://www.combinativ.com/' target="_blank">Developed by Combinativ</a></h4>
    </Container>
  </div>
)

const styles = {
  root: {
    padding: '50px',
    // backgroundColor: Theme.color.secondary,
    color: 'white'
  },
  title: {
    color: '#eee'
  },
  phoneNo: {
    color: '#eee',
    fontSize: '30px',
    marginLeft: '20px',
  },
  phoneTitle: {
    color: 'grey'
  },
  subtitle: {
    color: 'grey'
  }
}

export {Footer};